/** D19: asked once per plan at approval, when the plan has browser steps and the panel is hidden. */
export function WatchBrowserPrompt({ onAnswer }: { onAnswer: (watch: boolean) => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" role="dialog" aria-modal="true">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-5 shadow-xl">
        <h3 className="text-base font-semibold text-foreground">Watch the browser?</h3>
        <p className="mt-1 text-sm text-muted-foreground">Some steps run in your browser. ZAC can show the browser panel while it drives, or just do it.</p>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={() => onAnswer(false)} className="rounded-lg border border-border px-3 py-1.5 text-sm text-foreground hover:bg-secondary">Just do it</button>
          <button onClick={() => onAnswer(true)} className="rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90">Watch</button>
        </div>
      </div>
    </div>
  );
}
